import { render, staticRenderFns } from "./Supplier-barcode.vue?vue&type=template&id=67a33d70"
import script from "./Supplier-barcode.vue?vue&type=script&lang=js"
export * from "./Supplier-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports